import React, { useState } from 'react';
import Select from 'react-select';
import Menu from '@mui/material/Menu';

// styles
import { SELECT_CUSTOM_STYLE } from './SelectCustomStyle.style';
import s from './RunSelector.module.scss';

const DEFAULT_SLOT_PROPS = {
  list: { 'aria-labelledby': 'run-selector-button' },
  paper: {
    sx: {
      width: '350px',
      height: '350px',
      position: 'relative',
      minHeight: '350px',
      marginTop: '8px',
      backgroundColor: '#1A1A1D',
      boxShadow: 'none',
      overflow: 'hidden',
    },
  },
};

export interface RunOption {
  value: string;
  label: string;
  onClick: (option: RunOption) => void;
}

type Props = {
  runsOptions: RunOption[];
  clearSelectedRunOption: () => void;
  selectedRunOption: RunOption | null;
};

export const RunSelector = ({
  runsOptions = [],
  selectedRunOption = null,
  clearSelectedRunOption = () => {},
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClear = () => {
    clearSelectedRunOption();
    handleClose();
  };

  return (
    <div>
      <button
        id="run-selector-button"
        aria-controls={open ? 'run-selector-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={s.runSelectorButton}
      >
        <span className={s.label}>Run</span>
        <span className={s.value}>{selectedRunOption?.label ?? 'Select Run'}</span>
      </button>

      <Menu
        id="run-selector-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={DEFAULT_SLOT_PROPS}
      >
        <div className={s.runSelectorWrapper}>
          <Select
            autoFocus
            backspaceRemovesValue={false}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            menuIsOpen
            maxMenuHeight={300}
            onChange={(option) => {
              option?.onClick(option);
              handleClose();
            }}
            options={runsOptions}
            placeholder="Search..."
            styles={SELECT_CUSTOM_STYLE}
            classNamePrefix="runSelector"
            tabSelectsValue={false}
            value={selectedRunOption}
          />
        </div>

        <div className={s.menuFooter}>
          <button onClick={handleClear} className={s.clearButton}>
            Clear Runs Filter
          </button>
        </div>
      </Menu>
    </div>
  );
};
